import type { SupabaseClient } from '@supabase/supabase-js';
import { safeReturnTo } from '@garagegymbros/domain';

/** Server records completion once; an unfollow is never undone on later sign-ins. */
export async function memberSignInDestination(client: SupabaseClient, next: string | null) {
  const { data, error } = await client.rpc('complete_member_onboarding');
  if (error)
    throw new Error(
      'Your account is signed in, but welcome setup could not finish. Please try again.',
    );
  return data === true ? '/discover?view=members' : safeReturnTo(next);
}
